/**
 * DateSeparator (06 §4.5) + SystemMessage (06 §4.6) — both centered pills.
 * SystemMessage carries the pinned E2EE banner and group events.
 */
import { Lock } from 'lucide-react';
import { dateSeparator } from '../../lib/format';
import styles from './Pills.module.css';

export function DateSeparator({ ms }: { ms: number }) {
  return (
    <div className={styles.row}>
      <span className={styles.pill}>{dateSeparator(ms)}</span>
    </div>
  );
}

export function SystemMessage({ children }: { children: React.ReactNode }) {
  return (
    <div className={styles.row}>
      <span className={styles.pill}>{children}</span>
    </div>
  );
}

/** The pinned end-to-end-encryption banner at the top of every chat (06 §4.6). */
export function EncryptionBanner() {
  return (
    <div className={styles.row}>
      <span className={`${styles.pill} ${styles.encryption}`}>
        <Lock size={13} aria-hidden="true" />
        Messages are end-to-end encrypted. No one outside of this chat, not even
        Sinyal, can read them.
      </span>
    </div>
  );
}
